export default __webpack_public_path__ + "static/media/Golden_Cube_345.27a9b847.png";